var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":"","ripple":"","flat":"","plain":""},on:{"click":function($event){return _vm.navigate(_vm.destination)}}},[_c('span',{staticStyle:{"font-family":"linde","text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }